exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".number-box[data-v-cfba24c6]{display:inline;width:50px}", ""]);

// exports
